import React from 'react';
import Select, { OptionProps } from 'react-select';

interface MultiSelectProps {
  label?: string;
  labelTitle?: string;
  rounded?: number;
  border?: number;
  error?: string;
  options: { value: string | number; label: string }[];
  isDisabled?: boolean;
  value?: (string | number)[];
  required?: boolean;
  onChange?: (value: (string | number)[]) => void;
}

const Option = (props: OptionProps<any>) => {
  const { isSelected, isFocused, label, innerRef, innerProps } = props;

  let backgroundColor = 'white';
  let color = 'black';
  if (isSelected) {
    backgroundColor = '#d4b0f5';
    color = 'black';
  } else if (isFocused) {
    backgroundColor = '#f3eaff';
    color = 'black';
  }

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="d-flex my-1 rounded-4 align-items-center px-3 py-2"
      style={{
        cursor: 'pointer',
        width: '100%',
        backgroundColor,
        color,
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: 20,
          height: 20,
          borderRadius: 6,
          border: `2px solid ${isSelected ? '#5f00cc' : '#ccc'}`,
          background: isSelected ? '#5f00cc' : '#fff',
          marginRight: 8,
          position: 'relative',
          transition: 'all 0.15s',
        }}
      >
        {isSelected && (
          <svg
            width="14"
            height="14"
            viewBox="0 0 16 16"
            style={{
              position: 'absolute',
              top: 1,
              left: 1,
              display: 'block',
            }}
          >
            <polyline
              points="3,8 7,12 13,4"
              style={{
                fill: 'none',
                stroke: 'white',
                strokeWidth: 2.5,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
            />
          </svg>
        )}
      </span>
      <label className="form-check-label mb-0 w-100" style={{ color, cursor: 'pointer' }}>
        {label}
      </label>
    </div>
  );
};

export const MLMultiSelect: React.FC<MultiSelectProps> = ({
  label,
  labelTitle,
  error,
  border,
  rounded,
  options,
  value = [],
  isDisabled = false,
  ...props
}) => {
  return (
    <div>
      <label htmlFor="customMultiSelect" className={`form-label ${error ? 'text-danger' : ''} mb-1`}>
        {label}
        {props.required && <span className="text-danger m-1">*</span>}
      </label>

      <Select
        id="customMultiSelect"
        classNamePrefix="custom-select"
        options={options}
        isMulti
        components={{ Option }}
        isDisabled={isDisabled}
        value={options.filter(option => value.includes(option.value))}
        onChange={selectedOptions => {
          const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
          props.onChange?.(selectedValues);
        }}
        placeholder={labelTitle}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        menuPortalTarget={document.body}
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: error ? 'red' : base.borderColor,
            boxShadow: state.isFocused ? '0 0 0 2px rgba(95, 0, 204, 0.5)' : 'none',
            borderRadius: rounded ? `${rounded}px` : base.borderRadius,
          }),
          menuPortal: base => ({
            ...base,
            zIndex: 999999,
          }),
          menu: base => ({
            ...base,
            zIndex: 999999,
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#7700ff' : state.isFocused ? '#b683e6' : base.backgroundColor,
            color: state.isSelected || state.isFocused ? 'white' : 'black',
          }),
          multiValue: base => ({
            ...base,
            backgroundColor: '#7700ff',
            borderRadius: 6,
            padding: '2px 6px',
          }),
          multiValueLabel: base => ({
            ...base,
            color: 'white',
          }),
          multiValueRemove: base => ({
            ...base,
            color: 'white',
            ':hover': {
              backgroundColor: '#b683e6',
              color: '#7700ff',
            },
          }),
        }}
      />

      {error && <div className="text-danger w-100 d-block mt-1">{error}</div>}
    </div>
  );
};
